<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">
                Customized Translation <br />Service for Professionals
              </h1>
              <p class="text-lead text-white">
                You can dramatically reduce the translation time
                <br />by using the fast and accurate AI translator <br />through
                the services.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted">
                <div>
                  {{ message }}
                </div>
                <base-button
                  type="primary"
                  class="my-4"
                  @click="$router.replace('/login')"
                >
                  Go to OTran
                </base-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      message: '',
    }
  },
  computed: {},
  async created() {
    this.message = 'Email verification progress...'
    await this.$slowbro.post('/me/verify/email', {
      token: this.$route.query.token,
    })
    this.message = 'Email verification complete.'
  },
  methods: {},
}
</script>
